import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { EstimateExchange, CacheService } from 'mapfre-auditlib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class EstimateExchangeService {

  className = 'EstimateExchangeService'

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllEstimations(cache = true, cacheKey = "allEstimations"): Observable<any[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/types-change-predictions").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  insertOrUpdateEstimations(estimations: any[]) {
    return this.http.post(environment.base_URL + "/types-change-predictions", estimations);
  }

  updateEstimation(estimation, id) {
    return this.http.put(environment.base_URL + `/types-change-predictions/${id}`, estimation)
  }

  deleteEstimation(id: Number) {
    return this.http.delete(environment.base_URL + `/types-change-predictions/${id}`)
  }

  importEstimations(estimations: any[]) {
    return this.http.post(environment.base_URL + "/types-change-predictions/import", estimations);
  }
}
